// extracted by mini-css-extract-plugin
export default {"flexRow":"LatestOrderProductList_flexRow__brAbN","more":"LatestOrderProductList_more__Y6AM3"};